export const InputType = {
  Text: 'text',
  Number: 'number',
  Email: 'email',
  Password: 'password',
  Tel: 'tel',
  Button: 'button',
} as const;
export type InputType = (typeof InputType)[keyof typeof InputType];

export type InputSizeType = 'small' | 'large';

export type InputAutocompleteType =
  'off' | 'one-time-code' | 'username' | 'current-password' | 'new-password';
